import type { RouteObject } from 'react-router-dom';
import { Navigate, useParams } from 'react-router-dom';
import { CallsPage } from '~/pages/calls/calls';
import { callLogRoute } from '~/router/app/calls/log';
import { outboundCallsRoute } from '~/router/app/calls/outbound';
import { callReportRoute } from '~/router/app/calls/report';

function RedirectCallToLog() {
  const { id } = useParams();
  return <Navigate to={`/app/calls/log/${id}`} replace />;
}

export const callsRoute: RouteObject = {
  path: 'calls',
  element: <CallsPage />,
  children: [
    {
      index: true,
      element: <Navigate to="log" replace />
    },
    callLogRoute,
    outboundCallsRoute,
    callReportRoute,
    {
      path: ':id',
      element: <RedirectCallToLog />
    }
  ]
};
